/* eslint-disable import/no-unused-modules */

import useLiveSanityContent from "src/ssc-api/useLiveSanityContent";
import {
  SanityShorexData,
  SanityShorexSelectionCategoryItem,
  shorexContentQueryProjection,
  shorexesSelectionQuery
} from "@silversea-ssc/system-components-react/ShorexDrawer/utils";
import { isPresent } from "src/utils/checks";
import { useMemo } from "react";

export const useSanityShorexSelection = (cruiseCode: string) => {
  const { status, data } = useLiveSanityContent<
    SanityShorexSelectionCategoryItem[]
  >(shorexesSelectionQuery, {
    $cruiseCode: cruiseCode
  });

  return { status, data: data?.result || [] };
};

const cruiseShorexExcursionsQuery = `*[(_type == "cruiseData") && cruiseCode == $cruiseCode]
{
  itinerary[]{
      _key,
      "portId": port{_ref}._ref,
      "shorexes": confirmedShorexes[]{
        _key,
        duration,
        price,
        ...shorex->{
          ${shorexContentQueryProjection}
        }
      }
  }
}.itinerary[]`;

export type SanityCruiseItineraryShorexes = {
  _key: string;
  portId: string;
  shorexes: SanityCruiseItineraryShorexItem[];
};

export type SanityCruiseItineraryShorexItem = {
  _key: string;
  duration?: number;
  price?: number;
} & Omit<SanityShorexData, "name" | "category"> & {
    name: string;
    category: string;
  };

export const useSanityItineraryShorexes = (cruiseCode: string) => {
  const { status, data } = useLiveSanityContent<
    SanityCruiseItineraryShorexes[]
  >(cruiseShorexExcursionsQuery, {
    $cruiseCode: cruiseCode
  });

  const filteredResults = useMemo(
    () =>
      (data?.result || [])
        .map((x) => {
          return {
            ...x,
            shorexes: x.shorexes.filter(
              (s) => isPresent(s.category) && isPresent(s.name)
            )
          };
        })
        .filter((x) => x.shorexes.length > 0),
    [data?.result]
  );

  return { status, data: filteredResults };
};
